import React, { useState, useEffect } from 'react';
import { submitChildEducationForm, getAgentIdByToken } from '../services/api';
import '../css/ChildEducationForm.css';
import ChildEducationFormTranslations from './ChildEducationFormTranslations';
import Modal from '../components/Modal';

const ChildEducationForm = () => {
  const currentLanguage = 'en';
  const translations = ChildEducationFormTranslations[currentLanguage];

  // Form states
  const [numChildren, setNumChildren] = useState('');
  const [children, setChildren] = useState([]);
  const [usdToInr, setUsdToInr] = useState(80);
  const [totalCost, setTotalCost] = useState(0);
  const [exchangeRateMessage, setExchangeRateMessage] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [formTimestamp, setFormTimestamp] = useState('');
  const [showChildrenDetails, setShowChildrenDetails] = useState(false);

  // Personal details
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [mobile, setMobile] = useState('');
  const [cityOfResidence, setCityOfResidence] = useState('');
  const [otherCity, setOtherCity] = useState('');
  const [gender, setGender] = useState('');
  const [dob, setDob] = useState('');
  const [customerAge, setCustomerAge] = useState('');
  const [loadingAgent, setLoadingAgent] = useState(true);
  const [agentError, setAgentError] = useState('');
  
  

  // Error states
  const [errors, setErrors] = useState({});
  const [childrenErrors, setChildrenErrors] = useState([]);
   // Agent ID state with localStorage fallback
   const [agentId, setAgentId] = useState({});
   
// Fetch agent ID from backend using token in URL
    useEffect(() => {
        const fetchAgentId = async () => {
            try {
                // Extract token from URL path
                const pathParts = window.location.pathname.split('/');
                const token = pathParts[pathParts.length - 1];
                console.log("normal token child education111:");
                console.log("token: child education222", token);

                
                if (token) {
                    const response = await getAgentIdByToken(token);
                    console.log("==response child education==",response.data)
                   // console.log("==response child education==",response.data.agentId)
                   // console.log("==response child education==",response.data.agent_id)

                 
                    setAgentId(response.data);
                } else {
                    // Fallback to localStorage if token not found
                    const storedAgentId = localStorage.getItem("agentId");

                    if (storedAgentId) {
                        setAgentId(parseInt(storedAgentId, 10));
                    } else {
                        setAgentError("Agent information could not be loaded");
                    }
                }
            } catch (error) {
                console.error('Error fetching agent ID:', error);
                setAgentError("Failed to load agent information");
                
                // Fallback to localStorage
                const storedAgentId = localStorage.getItem("agentId");
                if (storedAgentId) {
                    setAgentId(parseInt(storedAgentId, 10));
                }
            } finally {
                setLoadingAgent(false);
            }
        };

        fetchAgentId();
    }, []);

  useEffect(() => {
    fetchExchangeRate();
    setExchangeRateMessage(translations.labels.exchange_rate_fetching || 'USD to INR Conversion Rate is being fetched...');
    setFormTimestamp(new Date().toISOString().slice(0, 19).replace('T', ' '));


      }, []);
    


  useEffect(() => {
    if (dob) {
      const dobDate = new Date(dob);
      const today = new Date();
      let age = today.getFullYear() - dobDate.getFullYear();
      const m = today.getMonth() - dobDate.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < dobDate.getDate())) {
        age--;
      }
      setCustomerAge(age);
    } else {
      setCustomerAge('');
    }
  }, [dob]);

  const fetchExchangeRate = async () => {
    try {
      const response = await fetch('https://api.exchangerate-api.com/v4/latest/USD');
      const data = await response.json();
      const rate = data.rates.INR;
      setUsdToInr(rate);
      setExchangeRateMessage(
        `${translations.labels.usd_to_inr_rate_is} ${rate.toFixed(2)} ${translations.labels.fetched_live}.`
      );
    } catch (error) {
      console.error(translations.errors.failedToFetchExchangeRate || 'Unable to fetch live USD to INR rate. Using default rate: 80.');
      setExchangeRateMessage(
        `${translations.labels.usd_to_inr_rate_is} 80.00 (${translations.labels.default_value}).`
      );
    }
  };

  const resetForm = () => {
    // Reset all form fields
    setName('');
    setEmail('');
    setMobile('');
    setCityOfResidence('');
    setOtherCity('');
    setGender('');
    setDob('');
    setCustomerAge('');
    setNumChildren('');
    setChildren([]);
    setChildrenErrors([]);
    setErrors({});
    setShowChildrenDetails(false);
    setTotalCost(0);
    // Update timestamp
    setFormTimestamp(new Date().toISOString().slice(0, 19).replace('T', ' '));
  };

  const generateChildForms = () => {
    const num = parseInt(numChildren);
    if (isNaN(num) || num < 0 || num > 5) {
      console.warn(translations.errors.invalidNumberOfChildren || "Please enter a number between 1 and 5.");
      setChildren([]);
      setChildrenErrors([]);
      return;
    }
    setChildren(Array(num).fill().map(() => ({
      name: '',
      gender: translations.data.genderOptions[0]?.value || 'Male',
      age: '',
      ugCostAbroadUsd: '',
      ugCostIndiaInr: '',
      mastersCostAbroadUsd: '',
      mastersCostIndiaInr: '',
    })));
    setChildrenErrors(Array(num).fill({}));
    setShowChildrenDetails(true);
  };

  const handleChildChange = (index, field, value) => {
    const updatedChildren = [...children];
    updatedChildren[index][field] = value;

    if (field === 'ugCostAbroadUsd' && value) {
      updatedChildren[index]['ugCostIndiaInr'] = '';
    } else if (field === 'ugCostIndiaInr' && value) {
      updatedChildren[index]['ugCostAbroadUsd'] = '';
    } else if (field === 'mastersCostAbroadUsd' && value) {
      updatedChildren[index]['mastersCostIndiaInr'] = '';
    } else if (field === 'mastersCostIndiaInr' && value) {
      updatedChildren[index]['mastersCostAbroadUsd'] = '';
    }

    setChildren(updatedChildren);

    const updatedChildErrors = [...childrenErrors];
    updatedChildErrors[index] = { ...updatedChildErrors[index], [field]: '' };
    setChildrenErrors(updatedChildErrors);
  };

  const validatePersonalDetails = () => {
    let newErrors = {};

    if (!name) newErrors.name = translations.errors.nameRequired;
    if (!email) {
      newErrors.email = translations.errors.emailRequired;
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      newErrors.email = translations.errors.invalidEmail;
    }
    if (!mobile) {
      newErrors.mobile = translations.errors.mobileRequired;
    } else if (!/^\d{10}$/.test(mobile) || /(.)\1{3}/.test(mobile)) {
      newErrors.mobile = translations.errors.invalidMobile;
    }
    if (!cityOfResidence) {
      newErrors.cityOfResidence = translations.errors.cityRequired;
    } else if (cityOfResidence === 'Others' && !otherCity) {
      newErrors.otherCity = translations.errors.requiredOtherCity;
    }
    if (!dob) {
      newErrors.dob = translations.errors.dobRequired;
    } else {
      const birthDate = new Date(dob);
      const today = new Date();
      birthDate.setHours(0, 0, 0, 0);
      today.setHours(0, 0, 0, 0);
      if (isNaN(birthDate.getTime()) || birthDate > today) {
        newErrors.dob = translations.errors.dateInvalid;
      }
    }
    if (!gender) newErrors.gender = translations.errors.genderRequired;

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validateChildrenDetails = () => {
    let newChildrenErrors = children.map(() => ({}));
    let allChildrenValid = true;

    if (children.length === 0 && parseInt(numChildren) > 0) {
      console.warn(translations.errors.numberOfChildrenRequired || "Please specify the number of children and generate their forms first.");
      return false;
    }
    if (children.length === 0 && parseInt(numChildren) === 0) {
      return true;
    }

    children.forEach((child, index) => {
      let childErrors = {};

      if (!child.name) childErrors.name = translations.errors.childNameRequired;

      const age = parseInt(child.age);
      if (isNaN(age) || age < 1 || age > 15) {
        childErrors.age = translations.errors.invalidChildAge || 'Age must be between 1 and 15.';
      }

      if (!child.ugCostAbroadUsd && !child.ugCostIndiaInr) {
        childErrors.ugCost = translations.errors.ugCostRequired || 'Please provide either UG cost abroad or in India.';
      } else {
        if (child.ugCostAbroadUsd && isNaN(parseFloat(child.ugCostAbroadUsd))) {
          childErrors.ugCostAbroadUsd = translations.errors.invalidUGCostAbroad || 'UG Cost Abroad must be a number.';
        }
        if (child.ugCostIndiaInr && isNaN(parseFloat(child.ugCostIndiaInr))) {
          childErrors.ugCostIndiaInr = translations.errors.invalidUGCostIndia || 'UG Cost India must be a number.';
        }
      }

      if (!child.mastersCostAbroadUsd && !child.mastersCostIndiaInr) {
        childErrors.mastersCost = translations.errors.mastersCostRequired || 'Please provide either Masters cost abroad or in India.';
      } else {
        if (child.mastersCostAbroadUsd && isNaN(parseFloat(child.mastersCostAbroadUsd))) {
          childErrors.mastersCostAbroadUsd = translations.errors.invalidMastersCostAbroad || 'Masters Cost Abroad must be a number.';
        }
        if (child.mastersCostIndiaInr && isNaN(parseFloat(child.mastersCostIndiaInr))) {
          childErrors.mastersCostIndiaInr = translations.errors.invalidMastersCostIndia || 'Masters Cost India must be a number.';
        }
      }

      newChildrenErrors[index] = childErrors;
      if (Object.keys(childErrors).length > 0) {
        allChildrenValid = false;
      }
    });

    setChildrenErrors(newChildrenErrors);
    return allChildrenValid;
  };

  const handleSubmitForm = async () => {
    if (!validatePersonalDetails() || !validateChildrenDetails()) {
      console.warn(translations.errors.validationFailed || "Please correct the form errors.");
      return;
    }

    let total = 0;
   //const agentId = localStorage.getItem("agentId");
   

    children.forEach((child) => {
      const age = parseInt(child.age);
      const yearsToUG = 18 - age;
      const yearsToMasters = 22 - age;

      const effectiveYearsToUG = Math.max(0, yearsToUG);
      const effectiveYearsToMasters = Math.max(0, yearsToMasters);

      const ugInflation = child.ugCostAbroadUsd ? 7.5 : 12;
      const mastersInflation = child.mastersCostAbroadUsd ? 7.5 : 12;

      let ugCost = 0;
      if (child.ugCostAbroadUsd) {
        ugCost = parseFloat(child.ugCostAbroadUsd) * Math.pow(1 + ugInflation / 100, effectiveYearsToUG) * usdToInr;
      } else if (child.ugCostIndiaInr) {
        ugCost = parseFloat(child.ugCostIndiaInr) * Math.pow(1 + ugInflation / 100, effectiveYearsToUG);
      }

      let mastersCost = 0;
      if (child.mastersCostAbroadUsd) {
        mastersCost = parseFloat(child.mastersCostAbroadUsd) * Math.pow(1 + mastersInflation / 100, effectiveYearsToMasters) * usdToInr;
      } else if (child.mastersCostIndiaInr) {
        mastersCost = parseFloat(child.mastersCostIndiaInr) * Math.pow(1 + mastersInflation / 100, effectiveYearsToMasters);
      }

      total += (ugCost + mastersCost);
    });

    setTotalCost(total);

    const formData = {
      'form_timestamp': formTimestamp,
      'name': name,
      'email': email,
      'mobile': mobile,
      'city_of_residence': cityOfResidence === 'Others' ? otherCity : cityOfResidence,
      'dob': dob,
      'customer_age': customerAge,
      'customer_gender': gender,
      'num_children': children.length,
      'agent_id': agentId, 
      'usd_to_inr_exchange_rate': usdToInr,
      'total_education_expenses_inr': total,
      'children_details': children.map(child => ({
        'child_name': child.name,
        'gender': child.gender,
        'age': parseInt(child.age),
        'ug_cost_abroad_usd': child.ugCostAbroadUsd ? parseFloat(child.ugCostAbroadUsd) : 0,
        'ug_cost_india_inr': child.ugCostIndiaInr ? parseFloat(child.ugCostIndiaInr) : 0,
        'masters_cost_abroad_usd': child.mastersCostAbroadUsd ? parseFloat(child.mastersCostAbroadUsd) : 0,
        'masters_cost_india_inr': child.mastersCostIndiaInr ? parseFloat(child.mastersCostIndiaInr) : 0,
      })),
    };

    try {
      const response = await submitChildEducationForm(formData);
      console.log("Form submitted successfully:", response.data);
      setShowModal(true);
    } catch (error) {
      console.error('Error submitting form:', error);
    }
  };

  return (
    <div className="child-education-form-container">
      <div className="child-education-form">
        <h1>{translations.labels.title}</h1>
        <p style={{ color: 'rgb(112, 16, 99)' }}>
          {translations.labels.description}
        </p>

        {/* Personal Details Section */}
        <div className="form-section">
          <h2 style={{ color: 'rgb(112, 16, 99)' }}>{translations.labels.personal_details}</h2>
          
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="formTimestamp">{translations.labels.form_timestamp}:</label>
              <input
                type="text"
                id="formTimestamp"
                value={formTimestamp}
                readOnly
                className="form-input"
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="name">{translations.labels.name}:</label>
              <input
                type="text"
                id="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder={translations.placeholders.name}
                className="form-input"
              />
              {errors.name && <p className="error-message">{errors.name}</p>}
            </div>

            <div className="form-group">
              <label htmlFor="email">{translations.labels.email}:</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder={translations.placeholders.email}
                className="form-input"
              />
              {errors.email && <p className="error-message">{errors.email}</p>}
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="mobile">{translations.labels.mobile}:</label>
              <input
                type="tel"
                id="mobile"
                value={mobile}
                onChange={(e) => setMobile(e.target.value)}
                placeholder={translations.placeholders.mobile}
                maxLength="10"
                className="form-input"
              />
              {errors.mobile && <p className="error-message">{errors.mobile}</p>}
            </div>

            <div className="form-group">
              <label htmlFor="cityOfResidence">{translations.labels.city_of_residence}:</label>
              <select
                id="cityOfResidence"
                value={cityOfResidence}
                onChange={(e) => {
                  setCityOfResidence(e.target.value);
                  if (e.target.value !== 'Others') {
                    setOtherCity('');
                  }
                }}
                className="form-select"
              >
                <option value="">{translations.placeholders.city_of_residence}</option>
                {translations.data.cityOptions.map(option => (
                  <option key={option.value} value={option.value}>{option.label}</option>
                ))}
              </select>
              {errors.cityOfResidence && <p className="error-message">{errors.cityOfResidence}</p>}
            </div>
          </div>

          {cityOfResidence === 'Others' && (
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="otherCity">{translations.labels.otherCity}:</label>
                <input
                  type="text"
                  id="otherCity"
                  value={otherCity}
                  onChange={(e) => setOtherCity(e.target.value)}
                  placeholder={translations.placeholders.otherCity}
                  className="form-input"
                />
                {errors.otherCity && <p className="error-message">{errors.otherCity}</p>}
              </div>
            </div>
          )}

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="gender">{translations.labels.gender}:</label>
              <select
                id="gender"
                value={gender}
                onChange={(e) => setGender(e.target.value)}
                className="form-select"
              >
                <option value="">{translations.placeholders.gender}</option>
                {translations.data.genderOptions.map(option => (
                  <option key={option.value} value={option.value}>{option.label}</option>
                ))}
              </select>
              {errors.gender && <p className="error-message">{errors.gender}</p>}
            </div>

            <div className="form-group">
              <label htmlFor="dob">{translations.labels.dob}:</label>
              <input
                type="date"
                id="dob"
                value={dob}
                onChange={(e) => setDob(e.target.value)}
                max={new Date().toISOString().split('T')[0]}
                placeholder={translations.placeholders.dob}
                className="form-input"
              />
              {errors.dob && <p className="error-message">{errors.dob}</p>}
            </div>
          </div>


        </div>

        {/* Children Section */}
        <div className="form-section">
          <h2 style={{ color: 'rgb(112, 16, 99)' }}>{translations.labels.child_detail}</h2>
          
          <div className="form-row">
            <div className="form-group">
              <label htmlFor="numChildren">{translations.labels.number_of_children}:</label>
              <select
                id="numChildren"
                value={numChildren}
                onChange={(e) => setNumChildren(e.target.value)}
                className="form-select"
              >
                <option value="">{translations.placeholders.number_of_children}</option>
                {translations.data.numberOfChildrenOptions.map(option => (
                  <option key={option} value={option}>{option}</option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <button
                onClick={generateChildForms}
                className="generate-button"
                disabled={!numChildren}
              >
                {translations.labels.generate_child_forms || "Generate Child Forms"}
              </button>
            </div>
          </div>

          {/* Only show children details after generation */}
          {showChildrenDetails && children.map((child, index) => (
            <div key={index} className="child-form-section">
              <h3 style={{ color: 'rgb(112, 16, 99)' }}>
                {translations.labels.child_number || "Child"} {index + 1}
              </h3>

              <div className="form-row">
                <div className="form-group">
                  <label>{translations.labels.child_name}:</label>
                  <input
                    type="text"
                    value={child.name}
                    onChange={(e) => handleChildChange(index, 'name', e.target.value)}
                    placeholder={translations.placeholders.child_name}
                    className="form-input"
                  />
                  {childrenErrors[index]?.name && <p className="error-message">{childrenErrors[index].name}</p>}
                </div>

                <div className="form-group">
                  <label>{translations.labels.gender}:</label>
                  <select
                    value={child.gender}
                    onChange={(e) => handleChildChange(index, 'gender', e.target.value)}
                    className="form-select"
                  >
                    {translations.data.genderOptions.map(option => (
                      <option key={option.value} value={option.value}>{option.label}</option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>{translations.labels.age} (1-15):</label>
                  <input
                    type="text"
                    value={child.age}
                    onChange={(e) => handleChildChange(index, 'age', e.target.value)}
                    className="form-input"
                    placeholder={translations.placeholders.age}
                    pattern="[0-9]*" 
                    inputMode="numeric" 
                  />
                  {childrenErrors[index]?.age && <p className="error-message">{childrenErrors[index].age}</p>}
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>{translations.labels.ugCostAbroadUsd || "UG Cost Abroad (USD)"}:</label>
                  <input
                    type="text"
                    value={child.ugCostAbroadUsd}
                    onChange={(e) => handleChildChange(index, 'ugCostAbroadUsd', e.target.value)}
                    disabled={!!child.ugCostIndiaInr}
                    className="form-input"
                    placeholder={translations.placeholders.ugCostAbroadUsd || "Enter UG Cost Abroad"}
                    pattern="[0-9]*" 
                    inputMode="numeric" 
                  />
                  {childrenErrors[index]?.ugCostAbroadUsd && <p className="error-message">{childrenErrors[index].ugCostAbroadUsd}</p>}
                </div>

                <div className="form-group">
                  <label>{translations.labels.ugCostIndiaInr || "UG Cost India (INR)"}:</label>
                  <input
                    type="text"
                    value={child.ugCostIndiaInr}
                    onChange={(e) => handleChildChange(index, 'ugCostIndiaInr', e.target.value)}
                    disabled={!!child.ugCostAbroadUsd}
                    className="form-input"
                    placeholder={translations.placeholders.ugCostIndiaInr || "Enter UG Cost India"}
                    pattern="[0-9]*" 
                    inputMode="numeric" 
                  />
                  {childrenErrors[index]?.ugCostIndiaInr && <p className="error-message">{childrenErrors[index].ugCostIndiaInr}</p>}
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>{translations.labels.mastersCostAbroadUsd || "Master's Cost Abroad (USD)"}:</label>
                  <input
                    type="text"
                    value={child.mastersCostAbroadUsd}
                    onChange={(e) => handleChildChange(index, 'mastersCostAbroadUsd', e.target.value)}
                    disabled={!!child.mastersCostIndiaInr}
                    className="form-input"
                    placeholder={translations.placeholders.mastersCostAbroadUsd || "Enter Master's Cost Abroad"}
                    pattern="[0-9]*" 
                    inputMode="numeric" 
                  />
                  {childrenErrors[index]?.mastersCostAbroadUsd && <p className="error-message">{childrenErrors[index].mastersCostAbroadUsd}</p>}
                </div>

                <div className="form-group">
                  <label>{translations.labels.mastersCostIndiaInr || "Master's Cost India (INR)"}:</label>
                  <input
                    type="text"
                    value={child.mastersCostIndiaInr}
                    onChange={(e) => handleChildChange(index, 'mastersCostIndiaInr', e.target.value)}
                    disabled={!!child.mastersCostAbroadUsd}
                    className="form-input"
                    placeholder={translations.placeholders.mastersCostIndiaInr || "Enter Master's Cost India"}
                    pattern="[0-9]*" 
                    inputMode="numeric" 
                  />
                  {childrenErrors[index]?.mastersCostIndiaInr && <p className="error-message">{childrenErrors[index].mastersCostIndiaInr}</p>}
                </div>
              </div>
            </div>
          ))}

          {/* Only show Submit button if children details are shown */}
          {showChildrenDetails && (
            <div className="form-actions">
              <button
                onClick={handleSubmitForm}
                className="submit-button"
              >
                {translations.labels.submit_form || "Submit"}
              </button>
            </div>
          )}
        </div>

        {/* Assumptions Section */}
        <div className="assumptions">
          <strong style={{ color: 'rgb(112, 16, 99)' }}>Assumptions:</strong>
          <ul>
            <li>{translations.labels.education_inflation_india || "Education Inflation in India"}: 12%</li>
            <li>{translations.labels.education_inflation_abroad || "Education Inflation Abroad"}: 7.5%</li>
            <li>{translations.labels.age_for_ug || "Age for UG"}: 18 {translations.labels.years}</li>
            <li>{translations.labels.age_for_masters || "Age for Masters"}: 22 {translations.labels.years}</li>
            <li>{exchangeRateMessage}</li>
          </ul>
        </div>

        {/* Success Modal */}
        <Modal show={showModal} onClose={() => {
          setShowModal(false);
          resetForm();
        }}>
          <h2>🎉 Form Submitted Successfully!</h2>
          <p>Thank you for your response.</p>
         
        </Modal>
      </div>
    </div>
  );
};

export default ChildEducationForm;